export const ErrorText = ({ children }) => {
    return (
        <h1 className="mt-1 font-gilroy-medium text-xs text-red-600">{children}</h1>
    );
};